import type { UserAuthStatus } from "./userAuthStatusType";

// The type is kept in a separate file because the function below relies on the type of `window` we've set
// in the web app in order to work. If the desktop app, which doesn't have those types set, imports this
// file, it complains that the function is accessing nonexistent stuff on window.

export function notifyDesktopAppOfAuth() {
	if (window.electron?.updateUserAuthStatus) {
		const currentURL = new URL(document.location.href);
		const info: UserAuthStatus =
			window.INITIAL_STATE.user && window.INITIAL_STATE.account
				? {
						userId: window.INITIAL_STATE.user.id,
						accountId: window.INITIAL_STATE.account.id,
						rootURL: currentURL.origin,
					}
				: null;

		window.electron.updateUserAuthStatus(info);
	}
}
